import React, {useState, useEffect, useContext} from "react";
import ServiceListing from "./ServiceListing";
import useServiceAps from "../hooks/useServiceAps";
import useDispatchServiceAp from "../hooks/useDispatchServiceAp";
import ServicePriceAnalysisEditor from "./ServicePriceAnalysisEditor";
import ServiceApPricelistUpload from "./ServiceApPricelistUpload";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import CountryContext from "../CountryContext";

const PAGE_SIZE = 10;


const ServiceChecklistListing = ({ serviceId, submittingAp, data }) => {

  // hooks
  const fetchAps = useServiceAps(serviceId, PAGE_SIZE);
  const dispatchAp = useDispatchServiceAp(serviceId);
  const { country } = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country?.code);

  // state
  const [selectedAp, setSelectedAp] = useState(null);
  const [edits, setEdits] = useState(0);
  const [service, setService] = useState();

  useEffect(async () => {
    const r = await countryApiRequest.get(`/services/${serviceId}`);
    setService(r);
  }, [serviceId]);


  return (
    <>
      {/* --------------- Listing --------------- */}
      <div className="flex justify-end ml-auto mb-6">
        <ServiceApPricelistUpload serviceId={serviceId} />
      </div>
      <ServiceListing
        edits={edits}
        setEdits={setEdits}
        onFetch={fetchAps}
        onClone={async (c) => {
          await dispatchAp(null, c);
        }}
        onOpen={(c) => {
          setSelectedAp(c);
        }}
        creatingNew={submittingAp}
        pageSize={PAGE_SIZE}
        cloneSuccessMessageId="ap_cloned_successfully"
        noItemsMessageId="aps_empty_list_message"
      />
      {/* --------------- Sidebar editor --------------- */}
      {!!selectedAp && service && (
        <div className="animate-slideIn w-3/4 md:w-1/2 lg:w-1/3 fixed inset-y-0 right-0 bg-white overflow-y-auto px-6 pb-6 shadow-2xl">
          <ServicePriceAnalysisEditor
            {...{
              service,
              selectedAp,
              setSelectedAp,
              setEdits,
              data,
            }}
          />
        </div>
      )}
    </>
  );
}

export default ServiceChecklistListing;